import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from 'react';
const defaultState = {
    info: {
        deliveryPromiseCutoff: null,
        hasDeliveryMessage: false,
    },
    optionError: {},
    selectedPaymentGroup: null,
    isSetPaymentGroupSuccess: false,
};
const PaymentContext = createContext([]);
export const usePaymentState = () => useContext(PaymentContext);
const reducer = (state, action) => {
    switch (action.type) {
        case 'set_payment_info':
            return Object.assign(Object.assign({}, state), { info: action.payload });
        case 'set_payment_klarna_token':
            return Object.assign(Object.assign({}, state), { klarnaToken: action.payload });
        case 'set_payment_option_error': // clear errors if payload is empty
            return Object.assign(Object.assign({}, state), { optionError: Object.assign({}, (action.payload ? Object.assign(Object.assign({}, state.optionError), action.payload) : {})) });
        case 'set_selected_payment_group':
            return Object.assign(Object.assign({}, state), { selectedPaymentGroup: action.payload });
        case 'set_payment_group_success':
            return Object.assign(Object.assign({}, state), { isSetPaymentGroupSuccess: action.payload });
        default:
            return state;
    }
};
export const CheckoutPaymentProvider = ({ children }) => {
    return _jsx(PaymentContext.Provider, { value: useReducer(reducer, Object.assign({}, defaultState)), children: children });
};
